import { observer } from 'mobx-react';

import { Document } from '@roc/feature-types';
import { InspectionReportDialog, PointOfContactDialog } from '@roc/feature-draws';
import { TaskStatus } from '@roc/feature-general-tasks';
import { TAKE_INTERNAL_VALUATION_PHOTOS_MANUAL } from '../../../constants/documentForms';

interface RealValPropertyPhotosDialogProps {
  open: boolean;
  onClose: () => void;
  document: Document;
}

export const RealValPropertyPhotosDialog = observer(({ open, onClose, document }: RealValPropertyPhotosDialogProps) => {
  const isManualUploadMode = document?.taskName === TAKE_INTERNAL_VALUATION_PHOTOS_MANUAL;
  const isPending = document?.status === TaskStatus.PENDING;
  // Manual skips PointOfContactDialog even when PENDING — there's no mobile "point of contact"
  // concept for a desktop upload, go straight to the upload screen.
  return isPending && !isManualUploadMode ? (
    <PointOfContactDialog
      open={open}
      onClose={onClose}
      document={document}
      isInternalValuationPropertyPhotosContactFlow
    />
  ) : (
    <InspectionReportDialog
      open={open}
      onClose={onClose}
      document={document}
      isInternalValuationPropertyPhotosContactFlow
      isManualUploadMode={isManualUploadMode}
    />
  );
});
